import { RouteObject, useRoutes } from 'react-router-dom';
import { RootLayout, SettingsLayout } from '../layout';
import {
  DashboardPage,
  DeviceDetailPage,
  DeviceRedirectGroupMain,
  LoginPage,
  MessageTemplateDetail,
  MessageTemplateMain,
  NumbersMain,
  QueueDistribution,
  SiteDetail,
  SiteMain,
  StatisticsMain,
  UserPage,
} from '../containers';

const Router = () => {
  const routes: RouteObject[] = [
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/',
      element: <RootLayout />,
      children: [
        {
          path: '/',
          index: true,
          element: <DashboardPage />,
        },
        {
          path: '/device/:id',
          element: <DeviceDetailPage />,
        },
        {
          path: '/statistics',
          element: <StatisticsMain />,
        },
        {
          path: '/numbers',
          element: <NumbersMain />,
        },
        {
          path: '/queue-distribution',
          element: <QueueDistribution />,
        },
      ],
    },
    {
      element: <SettingsLayout />,
      children: [
        {
          index: true,
          path: '/settings',
          element: <UserPage />,
        },
        {
          path: '/message-template',
          element: <MessageTemplateMain />,
        },
        {
          path: '/message-template/:id',
          element: <MessageTemplateDetail />,
        },
        {
          path: '/site',
          element: <SiteMain />,
        },
        {
          path: '/site/:id',
          element: <SiteDetail />,
        },
        {
          path: '/device-redirect-group',
          element: <DeviceRedirectGroupMain />,
        },
      ],
    },
  ];

  return useRoutes(routes);
};

export default Router;
